import { purpurBreakpointLg } from '@purpur/library/tokens';
import styled, { css } from 'styled-components';

import { Carousel } from '@telialt/common-carousel/src';
import { getPurpurColor, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

import { BlockArticlesColorOption, BlockArticlesDisplayOption } from './model';

export const StyledBlockArticles = styled.div<{ $colorOption: BlockArticlesColorOption }>`
    scroll-margin-top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    padding-bottom: ${getPurpurSpacing('400')};
    padding-top: ${getPurpurSpacing('400')};

    ${purpurMedia('lg')`
        padding-top: ${getPurpurSpacing('600')};
        padding-bottom: ${getPurpurSpacing('600')};
    `}

    ${({ $colorOption }) =>
        $colorOption === 'color-light-beige' && { background: getPurpurColor('backgroundToneOnToneTertiary') }}
`;

export const ArticleCardsGrid = styled.div.attrs({ role: 'list' })`
    display: grid;
    gap: ${getPurpurSpacing('300')};
`;
const carouselClass = 'block-articles-cards-carousel';
export const ArticleCardsCarousel = styled(Carousel).attrs({
    variant: 'dynamic-width',
    containerClassName: carouselClass,
})``;

export const DisplayOptionController = styled.div<{ $displayOption: BlockArticlesDisplayOption }>`
    container-type: inline-size;
    container-name: article-cards-grid;

    .${carouselClass} {
        padding: 0;
    }

    ${({ $displayOption }) => {
        switch ($displayOption) {
            case '1:1:1':
                return css`
                    .${carouselClass} {
                        ${purpurMedia('sm')`display: block;`}
                        ${purpurMedia('lg')`display: none;`}
                    }
                    ${ArticleCardsGrid} {
                        ${purpurMedia('sm')`display: none;`}
                        ${purpurMedia('lg')`
                            display: grid;
                            grid-auto-flow: column;
                        `}
                    }
                `;
            case '1:2':
                return css`
                    .${carouselClass} {
                        display: none;
                    }
                    ${ArticleCardsGrid} {
                        ${purpurMedia('sm')`grid-auto-flow: row;`}

                        @container article-cards-grid (min-width: ${purpurBreakpointLg}) {
                            grid-template:
                                'a b' auto
                                'a c' auto / auto minmax(600px, 55%);
                            > :first-child {
                                grid-area: a;
                            }
                        }
                    }
                `;
            case '1:3':
                return css`
                    .${carouselClass} {
                        display: none;
                    }
                    ${ArticleCardsGrid} {
                        ${purpurMedia('sm')`grid-auto-flow: row;`}
                        ${purpurMedia('md')`grid-template-columns: repeat(2, 1fr);`}
                        ${purpurMedia('lg')`
                            grid-template:
                                'a a a' auto
                                'b c d' auto / 1fr 1fr 1fr;
                            > :first-child { grid-area: a; }
                        `}
                    }
                `;
            case 'standalone':
                return css`
                    .${carouselClass} {
                        display: none;
                    }
                    ${ArticleCardsGrid} {
                        display: block;
                    }
                `;
            default:
                return '';
        }
    }}
`;
